import { UserAvatarSize } from './interfaces/svz-user-avatar.interface';

export const DEFAULT_USER_AVATAR_SIZE = 30;
export const WORKSPACE_USER_AVATAR_SIZE = 150;

export function normalizeUserAvatarSize(size?: UserAvatarSize | null): number {
  return (size === UserAvatarSize.Workspace ? WORKSPACE_USER_AVATAR_SIZE : size) ?? DEFAULT_USER_AVATAR_SIZE;
}
